import React from 'react'
import Layout from '../../Layout/Layout'
import toolkit1 from '../../images/toolkit1.PNG'
import toolkit2 from '../../images/toolkit2.PNG'
import toolkit3 from '../../images/toolkit3.PNG'

const Research_to_commerce_toolkit = () => {
  return (
    <Layout>
        <div className='uk-container'>
            <div>
                <h2 className='light uk-text-bold uk-margin-xlarge-top'>Research to Commercialization Toolkit Validation workshop
</h2>
                
                
                </div>
            <div className='uk-grid'>
               <div className='uk-width-1-2@s'>
                      <p className='light'>The Research to Commercialization (R2C) Toolkit Validation
                         Workshop was a pivotal event organized by the Impact Investors Foundation 
                         (IIF) under the auspices of the Nigeria Impact Investing Research Industry 
                         Collaborative (NIIRIC), with support from RISA and the Ford Foundation.
                          The workshop's primary goal was to subject the draft R2C Toolkit—a 
                          comprehensive framework designed to bridge the gap between research
                           and market-ready innovation—to rigorous peer review. 
</p>

                <p className='light'>The event successfully brought together 77 participants 
                    (37 physical, 40 virtual) from diverse stakeholder groups, including 
                    academia, government, industry, and development partners, to ensure 
                    the toolkit's practical relevance within the Nigerian context.</p>

               </div>

                <div className='uk-width-1-2@s'>
                     <img src={toolkit1} />
               </div>
            </div>




               <div className='uk-grid'>
               <div className='uk-width-1-2@s'>
                 <img src={toolkit2} />
               </div>

                <div className='uk-width-1-2@s'>

                <p className='light'>The workshop's key objectives were to validate the draft R2C Toolkit,
                     refine the overall commercialization framework by incorporating expert feedback,
                      and build stakeholder consensus for its adoption and implementation. The draft
                       toolkit, developed with Moolu Venture Lab serving as the facilitator, was 
                       structured around four critical phases of the innovation lifecycle: Discovery 
                       & Ideation, Validation & Development, Protection & Positioning, and
                        Commercialization & Scaling. The validation process served to build 
                        ownership among co-creators and identify gaps, such as the need for
                         clearer guidance on Intellectual Property (IP) processes and practical
                          tools for investment readiness assessment.
</p>

               


                  
               </div>
            </div>


            <div className='uk-grid'>
              

               <div className='uk-width-1-2@s'>
                 <p className='light'> A crucial part of the validation was the Group
                     Breakout and Validation Process, where multidisciplinary teams 
                     reviewed thematic areas. The resulting consolidated feedback 
                     generated over 72 recommendations that were transformed into 
                     actionable inputs for the final revision. Key structural and 
                     organizational recommendations included developing three sub
                     -frameworks tailored for Academic/Research Institutions,
                      Independent Innovators/MSMEs, and Policy/Ecosystem Builders,
                       and refining the stage-gate structure with entry/exit criteria.
                        The consultant, Prince Ogbonna, CEO of Moolu Venture Lab, accepted 
                        major feedback, agreeing to reorganize the structure into a flexible
                         five-part framework and ensure full alignment with the National Science, 
                         Technology and Innovation Policy (NSTIP 2022)</p>
              </div>

              <div className='uk-width-1-2@s'>
                <img src={toolkit3} />
              </div>
            </div>
        </div>
        </Layout>
  )
}

export default Research_to_commerce_toolkit